import React from 'react';
import * as S from "./styles";
import { Visibility } from "components/Visibility";
interface IndicatorsProps {
  priorityItem: boolean;
  iconIndicator: string;
  titleIndicator: string;
  hasButton: boolean;
}
const IndicatorItem: React.FC<IndicatorsProps> = ({ priorityItem, iconIndicator, titleIndicator, hasButton}) => {
  return (
    <Visibility visible={priorityItem}>
      <S.IndicatorsContainer hasButton={hasButton}>
        <S.IndicatorItem>
          <S.IndicatorIcon src={iconIndicator} alt={titleIndicator}/>
          <S.IndicatorText>{titleIndicator}</S.IndicatorText>
        </S.IndicatorItem>
      </S.IndicatorsContainer>
    </Visibility>
  );
};
export default IndicatorItem;